import React from 'react';
import { event } from '../utils/gtm';

/**
 * A component that displays pricing options for the user.
 *
 * @param {object} props - The component props.
 * @param {function(priceId: string, mode: 'subscription' | 'payment'): void} props.handleCheckout - Function to handle the checkout process.
 */
const PricingPage = ({ handleCheckout, user }) => {  
  // Placeholder Stripe Price IDs. These should be replaced with actual IDs from your Stripe account.
  const proPlanPriceId = 'price_1SO6pGLTkxYREHomoKBOOgq5';
  const creditPackPriceId = 'price_1SO74jLTkxYREHomLa9jy7yZ';

  return (
    <div className="pricing-page-container mx-auto">
      <h1 className="text-3xl font-bold text-center mb-12">Find the Right Plan for You</h1>
      <div className="flex flex-col lg:flex-row items-stretch justify-center gap-8">
        {/* Free Plan Card */}
        <div className="pricing-card lg:flex-1 text-center lg:text-left">
          <div className="pricing-card-inner">
            <div className="pricing-card-header">
              <h2 className="pricing-card-title">Free</h2>
              <p className="pricing-card-price">$0 / month</p>
            </div>
            <p className="pricing-card-description">
              For creators just getting started.
            </p>
            <ul className="pricing-card-benefits flex flex-col items-center lg:items-start">
              <li>10 Daily Credits</li>
              <li>Basic Keyword Research</li>
              <li>Limited Channel Analysis</li>
              <li>Track 3 Competitors</li>
              <li>Basic Script Intelligence</li>
            </ul>
            <button
              className="pricing-card-button is-secondary rounded-full"
              disabled="true"
            >
              {user?.plan === 'free' ? 'Your Current Plan' : 'Included'}
            </button>
          </div>
        </div>
        {/* Pro Plan Card */}
        <div className="pricing-card is-pro lg:flex-1 text-center lg:text-left">
          <div className="pricing-card-inner">
            <div className="pricing-card-header">
              <h2 className="pricing-card-title">Pro</h2>
              <p className="pricing-card-price">$10 / month</p>
            </div>
            <p className="pricing-card-description">
              For serious creators ready to grow.
            </p>
            <ul className="pricing-card-benefits flex flex-col items-center lg:items-start">
              <li>Everything in Free, plus:</li>
              <li>250 Monthly Credits</li>
              <li>Advanced Keyword Analysis (SERP)</li>
              <li>Track 10 Competitors</li>
              <li>Full Script Intelligence Suite</li>
              <li>Priority Support</li>
            </ul>
            <button
              className="pricing-card-button rounded-full bg-gradient-to-r from-[#1d94d0] to-[#1E3A8A] transition-all duration-300 hover:shadow-lg hover:shadow-[#1d94d0]/40 hover:brightness-110"
              onClick={() => handleCheckout(proPlanPriceId, 'subscription')}
              disabled={user?.plan === 'pro'}
            >
              {user?.plan === 'pro' ? 'Your Current Plan' : 'Upgrade to Pro'}
            </button>
          </div>
        </div>

        {/* Credit Pack Card */}
        <div className="pricing-card lg:flex-1 text-center lg:text-left">
          <div className="pricing-card-inner">
            <div className="pricing-card-header">
              <h2 className="pricing-card-title">Credit Pack</h2>
              <p className="pricing-card-price">$5 one-time</p>
            </div>
            <p className="pricing-card-description">
              Top up your account with extra credits that never expire.
            </p>
            <ul className="pricing-card-benefits flex flex-col items-center lg:items-start">
              <li>50 Purchased Credits</li>
              <li>Credits Never Expire</li>
              <li>No Subscription Needed</li>
            </ul>
            <button
              className="pricing-card-button rounded-full bg-gradient-to-r from-[#1d94d0] to-[#1E3A8A] transition-all duration-300 hover:shadow-lg hover:shadow-[#1d94d0]/40 hover:brightness-110"
              onClick={() => handleCheckout(creditPackPriceId, 'payment')}
            >
              Buy Credits
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;